import { null as null_, object, string } from "zod/v4";

export const setMultipassSecret = {
  name: "setMultipassSecret" as const,
  input: object({ teamId: string(), secret: string() }),
  output: null_(),
};
